// src/routes/agentsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Agents from '../pages/agents/Agents';
import CreateAgent from '../pages/agents/CreateAgent';
import EditAgent from '../pages/agents/EditAgent';
import ProtectedRoute from '../components/global/ProtectedRoute';

const agentsRoutes = (
    <>
        {/* Agents List */}
        <Route
            path="/agents"
            element={
                <ProtectedRoute requiredPermission="agents_list">
                    <Agents />
                </ProtectedRoute>
            }
        />

        {/* Agents Archive */}
        <Route
            path="/agents/archive"
            element={
                <ProtectedRoute requiredPermission="agents_archive_list">
                    <Agents />
                </ProtectedRoute>
            }
        />

        {/* Create Agent */}
        <Route
            path="/agents/create"
            element={
                <ProtectedRoute requiredPermission="agents_create">
                    <CreateAgent />
                </ProtectedRoute>
            }
        />

        {/* Edit Agent */}
        <Route
            path="/agents/:id/edit"
            element={
                <ProtectedRoute requiredPermission="agents_edit">
                    <EditAgent />
                </ProtectedRoute>
            }
        />
    </>
);

export default agentsRoutes;
